import { render } from "./filledholes.vue?vue&type=template&id=3defdd83"
import script from "./filledholes.vue?vue&type=script&lang=js"
export * from "./filledholes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__